


  //float on scroll

  (() => {
    const elements = document.querySelectorAll('.float');
    if (!elements.length) return;

    elements.forEach((el) => {
      el.style.willChange = 'transform';
      el.style.transition = 'transform 0.1s linear';
    });

    window.addEventListener('scroll', () => {
      requestAnimationFrame(() => {
        elements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          const center = rect.top + rect.height / 2;
          const viewCenter = window.innerHeight / 2;
          const offset = (center - viewCenter) * -0.08;
          el.style.transform = `translateY(${offset}px)`;
        });
      });
    });
  })();


    //end of float on scroll
